export default "__VITE_ASSET__fa16dbd9__"